// Fronted/src/components/admin/homescreens/MinistriesSection.jsx
import React from "react";
import { Link } from "react-router-dom";
import { useMinistries } from '../../contexts/MinistryContext';

const MinistriesSection = () => {
  const {ministries} = useMinistries();

  if (!ministries){<div>Loading...</div>}
 
  return (
    <div className="w-full bg-white rounded-lg shadow-lg p-4 mt-4">
      <h2 className="text-xl font-bold text-gray-800 mb-1">Family</h2>
      <p className="text-sm text-primary font-bold mb-4">
        See what God can do through your family.
      </p>
      <ul className="w-full">
        {
          ministries.map((ministry) => (
          <li className="w-full py-2">
            <Link className="flex items-center text-black hover:text-primary transition-colors font-bold" to={`${ministry.name}-ministry/?ministryId=${ministry.id}`}>
            <div className="w-10  border-3  rounded-[100%] flex">
            <img src={ministry.logo_image} alt={ministry.name}  className="w-full "/>
            </div>
            <span>{ministry.name}</span>
            </Link>
          </li>))
        }
        
      </ul>
    </div>
  );
};

export default MinistriesSection;